














import { Component, Prop, Vue } from 'vue-property-decorator'
import { Room } from '@/class/room'
import { GameState } from '@/enum'
import { GAME_STATE } from '@/class/const'
import InputText from '@/components/Utils/form/text/InputText.vue'
import HeadlineDot from '@/components/Utils/headline/HeadlineDot.vue'


@Component({
  components: {
    InputText,
    HeadlineDot
  }
})
export default class TimerSettings extends Vue {
  @Prop() room!: Room;

  get timerSettings () {
    return [
      { key: GameState.ready, label: GAME_STATE[GameState.ready] },
      { key: GameState.firstNight, label: GAME_STATE[GameState.firstNight] },
      { key: 'dayByLiver', label: '1人当たりの議論時間' },
      { key: 'dayMax', label: '最長議論時間' },
      { key: GameState.voteStart, label: GAME_STATE[GameState.voteStart] },
      { key: GameState.voteEnd, label: GAME_STATE[GameState.voteEnd] },
      { key: GameState.finalVoteReady, label: GAME_STATE[GameState.finalVoteReady] },
      { key: GameState.finalVoteStart, label: GAME_STATE[GameState.finalVoteStart] },
      { key: GameState.takeOther, label: GAME_STATE[GameState.takeOther] },
      { key: GameState.night, label: GAME_STATE[GameState.night] }
    ]
  }

  updateRoom () {
    this.room.updateRoom()
  }
}
